<template>
  <div>
    <div class="mobile">Deze generator werkt alleen op desktop</div>
    <full-page id="generator" ref="fullpage" :options="fpOptions">
    <div class="section">
      <div class="fp-wrap">
        <div class="fp-wrap--50 fp-wrap__theme1">
          <div class="info">
            <h1>E-mail handtekening</h1>
            <em>Vul je gegevens in en klik op genereren.</em>
            <p>Velden die je leeg laat worden niet getoond in je handtekening.</p>
          </div>
        </div>
        <div class="fp-wrap--50">
          <div class="form">
            <form @submit="submitForm">
              <label for="input-firstname">Voornaam</label>
              <input type="text" id="input-firstname" placeholder="John" v-model="formData.firstname" />

              <label for="input-firstname">Tussenvoegsel</label>
              <input type="text" id="input-tussenvoegsel" placeholder="van der" v-model="formData.tussenvoegsel" />

              <label for="input-lastname">Achternaam</label>
              <input type="text" id="input-lastname" placeholder="Doe" v-model="formData.lastname" />

              <label for="input-func">Functietitel</label>
              <input type="text" id="input-func" placeholder="Developer" v-model="formData.func" />

              <label for="input-phone">06-nummer</label>
              <VuePhoneNumberInput
                v-model="formData.phone"
                default-country-code="NL"
                :no-country-selector="true"
                :no-example="true"
                :label="false"
                :translations="{
                  phoneNumberLabel: '06 12345678',
                }"
                @update="onUpdatePhone"
              />

              <label for="input-email">E-mailadres</label>
              <input type="text" id="input-email" placeholder="john.doe@wearefrank.nl" v-model="formData.email" />

              <label for="input-marketing">Marketing</label>
              <select id="input-marketing" v-model="formData.marketing.type">
                <option value="">Geen</option>
                <option value="tvblog">Frank! insights</option>
                <option value="adviesgesprek">Adviesgesprek</option>
                <option value="aangepast">Aangepaste link</option>
              </select>

              <div v-if="formData.marketing.type == 'adviesgesprek'">
                <label for="input-advies-link">Link naar adviesgesprek</label>
                <input type="text" id="input-advies-link" v-model="formData.marketing.link" placeholder="https://calendly.com/john-doe/adviesgesprek" />
              </div>


              <div v-if="formData.marketing.type == 'aangepast'">
                <label for="input-link-link">URL</label>
                <input type="text" id="input-link-link" v-model="formData.marketing.link" placeholder="https://wearefrank.nl" />

                <label for="input-link-text">Linktekst</label>
                <input type="text" id="input-link-link" v-model="formData.marketing.text" placeholder="Ga naar de website van WeAreFrank!" />
              </div>

              <button type="submit">Genereren</button>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="section">
      <div class="fp-wrap">
        <div class="fp-wrap--50">
          <button class="btn-back button--secondary" @click="$refs.fullpage.api.moveSectionUp();">&lt; Terug</button>
          <div class="info">
            <h1>Je handtekening is klaar!</h1>
            <em>Kopieer en plak in je e-mailclient.</em>
            <p>Hulp nodig bij het instellen? <br/><a target="_blank" href="https://support.office.com/en-us/article/create-and-add-a-signature-to-messages-8ee5d4f4-68fd-464a-a1c1-0e1c80bb27f2">Bekijk de instructies voor Outlook</a></p>
          </div>
        </div>
        <div class="fp-wrap--50 fp-wrap__theme1">
          <div class="tac">
            <SignatureComponent class="signature" ref="signature" :data="formData" />
            <div class="actions">
              <button @click="copySignature()">Kopieer</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </full-page>
  </div>
</template>

<script>
import SignatureComponent from './components/signature-2';
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

export default {
  components: {
    VuePhoneNumberInput,
    SignatureComponent
  },
  data() {
    return {
      formData: {
        firstname: "",
        tussenvoegsel: "",
        lastname: "",
        func: "",
        phone: null,
        email: "",
        marketing: {
          type: "tvblog",
          link: "",
          text: ""
        }
      },
      phoneNumber: {},
      fpOptions: {
        menu: true,
        sectionsColor: ['#F8FBFD', '#F8FBFD']
      }
    };
  },
  methods: {
    onUpdatePhone(payload) {
      this.formData.phoneNumber = payload;
    },
    submitForm(e) {
      e.preventDefault();
      this.$refs.fullpage.api.moveSectionDown();
    },
    copySignature() {
      var source = this.$refs.signature.$refs.signaturediv;
      var range = document.createRange();
      var selection = window.getSelection();

      range.selectNodeContents(source);
      selection.removeAllRanges();
      selection.addRange(range);

      try {
        var successful = document.execCommand('copy');
        var callback = successful ? 'onSuccess' : 'onError';
        this.$toasted.success( 'Handtekening gekopieerd');
      } 
      catch (err) { 
        this.$toasted.success('Er is iets mislukt bij het kopieren van je handtekening');
      }
      selection.removeAllRanges();
    }
  }
};
</script>

<style lang="scss">
.iets{}
</style>